import React from 'react'
import Button from '../../ui/Button'

const CloseUnsaved = ({ onClose, onCancel }) => {
  return (
     <div className="fixed inset-0 flex text-start items-center justify-center bg-black bg-opacity-10 z-50 p-4">
    <div className='bg-white relative w-xs p-4 rounded-md'>
    <p className='text-center text-lg font-semibold my-4'> There are unsaved changes, do you want to close?</p>
    <div className='flex gap-2 justify-center items-center'>
    <Button className='mr-2' onClick={onClose} variant='danger'>Yes</Button>
    <Button onClick={onCancel} variant='secondary'>No</Button>
    </div>
    </div>
    </div>
  )
}

export default CloseUnsaved